import { useNavigate } from 'libs/navigation';
import { Button, ButtonProps } from 'libs/ui';

export interface ButtonNavigationLinkProps
  extends Omit<ButtonProps, 'onClick'> {
  to: string;
}

export const ButtonNavigationLink = ({
  to,
  ...buttonProps
}: ButtonNavigationLinkProps) => {
  const { navigate } = useNavigate();

  return (
    <Button {...buttonProps} onClick={(event) => navigate(to, {}, { event })} />
  );
};
